module.exports = __webpack_public_path__ + "static/media/defaultPackage.cb15e241.jpg";